import {
  Box,
  Divider,
  Grid2,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { tokens } from "../../theme";

const RequestPayment = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box justifyItems="center">
      <Paper
        sx={{
          width: "70%",
          padding: "10px",
          borderRadius: "8px",
          marginBottom: "15px",
          width: "210mm",
          height: "297mm",
          padding: "45px 15px 20px 15px",
        }}
        elevation={3}
      >
        <Box
          sx={{
            marginTop: "15px",
            marginBottom: "15px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h2" color="secondary" sx={{ fontWeight: 700 }}>
            #INVOICE
          </Typography>
          <Grid2 container display={"block"} textAlign={"right"}>
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
              MATERIAL TESTING LABORATORY - KEKIRAWA
            </Typography>
            <Typography variant="h5">
              PROVINCIAL ENGINEERING DEPARTMENT - NORTH CENTRAL PROVINCE
            </Typography>
          </Grid2>
        </Box>

        <Divider sx={{ marginBottom: "15px" }} />

        <Box sx={{ marginTop: "15px" }}>
          <Grid2 container spacing={1}>
            <Grid2 size={5}>
              <Paper elevation={2} sx={{ padding: "10px", height: "100%" }}>
                <Grid2 container spacing={2}>
                  <Grid2 size={4}>
                    <Box display="flex" alignItems="center" columnGap="10px">
                      <Typography variant="h5" sx={{ fontWeight: 700 }}>
                        Invoice No
                      </Typography>
                    </Box>
                  </Grid2>
                  <Grid2 size={1}>
                    <Typography
                      variant="h5"
                      component="h2"
                      sx={{ fontWeight: 700 }}
                    >
                      :
                    </Typography>
                  </Grid2>
                  <Grid2 size={7}>
                    <Typography variant="h5" component="h2">
                      Inv001
                    </Typography>
                  </Grid2>

                  <Grid2 size={4}>
                    <Box display="flex" alignItems="center" columnGap="10px">
                      <Typography variant="h5" sx={{ fontWeight: 700 }}>
                        Invoice Date
                      </Typography>
                    </Box>
                  </Grid2>
                  <Grid2 size={1}>
                    <Typography
                      variant="h5"
                      component="h2"
                      sx={{ fontWeight: 700 }}
                    >
                      :
                    </Typography>
                  </Grid2>
                  <Grid2 size={7}>
                    <Typography variant="h5" component="h2">
                      2025-01-25
                    </Typography>
                  </Grid2>
                  <Grid2 size={4}>
                    <Box display="flex" alignItems="center" columnGap="10px">
                      <Typography variant="h5" sx={{ fontWeight: 700 }}>
                        Job No
                      </Typography>
                    </Box>
                  </Grid2>
                  <Grid2 size={1}>
                    <Typography
                      variant="h5"
                      component="h2"
                      sx={{ fontWeight: 700 }}
                    >
                      :
                    </Typography>
                  </Grid2>
                  <Grid2 size={7}>
                    <Typography variant="h5" component="h2">
                      JOB2025/1
                    </Typography>
                  </Grid2>
                </Grid2>
              </Paper>
            </Grid2>
            <Grid2 size={7}>
              <Paper elevation={2} sx={{ padding: "10px", height: "100%" }}>
                <Grid2 container spacing={1.75} textAlign={"right"}>
                  <Grid2 size={12}>
                    <Typography variant="h4">INVOICE TO</Typography>
                  </Grid2>
                  {/* <TextSnippet sx={{ color: colors.greenAccent[500] }} /> */}
                  <Grid2 size={12}>
                    <Typography variant="h5">
                      SACO Constructions Motor Engineer
                    </Typography>
                  </Grid2>

                  <Grid2 size={12}>
                    <Typography variant="h5" component="h2">
                      Anuradhapura
                    </Typography>
                  </Grid2>
                </Grid2>
              </Paper>
            </Grid2>
          </Grid2>
        </Box>
        <Divider sx={{ marginBottom: "15px", marginTop: "15px" }} />
        <Box
          display="grid"
          gap="8px"
          gridTemplateColumns="repeat(12, minmax(0, 1fr))"
          sx={{
            "& > div": {
              gridColumn: isNonMobile ? undefined : "span 12",
            },
          }}
        >
          <Typography sx={{ gridColumn: "span 12" }} variant="h5">
            Project Name
          </Typography>
          <Divider sx={{ gridColumn: "span 12" }} />
          <Typography
            textAlign="center"
            variant="h5"
            alignContent="center"
            sx={{
              gridColumn: "span 1",
              marginTop: "8px",
              fontWeight: 800,
            }}
          >
            No.
          </Typography>
          <Typography
            textAlign="center"
            variant="h5"
            alignContent="center"
            sx={{
              gridColumn: "span 5",
              marginTop: "8px",
              fontWeight: 800,
            }}
          >
            Test Name
          </Typography>
          <Typography
            textAlign="center"
            variant="h5"
            alignContent="center"
            sx={{
              gridColumn: "span 2",
              marginTop: "8px",
              fontWeight: 800,
            }}
          >
            Rate (Rs.)
          </Typography>
          <Typography
            textAlign="center"
            variant="h5"
            alignContent="center"
            sx={{
              gridColumn: "span 2",
              marginTop: "8px",
              fontWeight: 800,
            }}
          >
            Quantity
          </Typography>
          <Typography
            textAlign="center"
            variant="h5"
            alignContent="center"
            sx={{
              gridColumn: "span 2",
              marginTop: "8px",
              fontWeight: 800,
            }}
          >
            Total
          </Typography>
        </Box>
        <Divider sx={{ margin: "10px 0 10px 0" }}></Divider>
        {/* {invoiceData.tests.map((data, index) => {
          return <TableData data={data} />;
        })} */}

        <Divider sx={{ margin: "15px 0 15px 0" }}></Divider>
        <Box
          display="grid"
          gap="8px"
          width="100%"
          gridTemplateColumns="repeat(3, minmax(0, 1fr))"
        >
          <Typography
            textAlign="right"
            color={colors.greenAccent[600]}
            variant="h4"
            alignContent="center"
            sx={{
              gridColumn: "span 2",
              marginTop: "2px",
              fontWeight: 800,
            }}
          >
            Total Amount
          </Typography>
          <Typography
            textAlign="right"
            color={colors.greenAccent[600]}
            variant="h4"
            alignContent="center"
            sx={{
              gridColumn: "span 1",
              marginTop: "2px",
              fontWeight: 800,
            }}
          >
            as
          </Typography>
          <Divider
            sx={{ margin: "2px 0 2px 0", gridColumn: "span 3" }}
          ></Divider>
        </Box>
      </Paper>
    </Box>
  );
};

export default RequestPayment;
